import React from 'react';
import { SingleDatePicker } from 'react-dates';

export default class FilterDateSelect extends React.Component {

  state = {open: false, value: null};

  toggleOpen = () => {
    this.setState({
      open: !this.state.open
    });
  };


  handleChange = data => {
    this.props.handleChange({[this.props.name]: data})
  };

  mock = () => {

  };

  open = () => {
    this.setState({open: true})
  };

  componentWillReceiveProps = newProps => {
    this.setState({value: newProps.value})
  };

  deleteDate = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props.handleChange({[this.props.name]: null})
  };

  render(){
    const close = <span key="suka" style={{marginLeft: 5}} onClick={this.deleteDate}>{CLOSE_ICON}</span>;
    return (
      <div className="col-6" onClick={this.open}>
        <label className="filter-item" style={{marginBottom: 5}} >
          <span className="date">
            <i className="ic-map-ico"/>
            {this.state.value ? [this.state.value.format('D MMM`YY'), close] : this.props.placeholder }
          </span>


          <SingleDatePicker
            showClearDate={true}
            placeholder="Start date"
            numberOfMonths={1}
            date={this.state.value}
            onDateChange={this.handleChange}
            focused={this.state.open}
            onFocusChange={this.toggleOpen}/>
        </label>



      </div>
    )
  }
}
const CLOSE_ICON = (<svg  width="10" height="9">
  <path fill="#8aa3ae" fillRule="evenodd" d="M2.292.758L.947 2.104l2.7 2.7-2.7 2.7L2.292 8.85l2.701-2.7 2.7 2.7 1.346-1.346-2.701-2.7 2.701-2.7L7.693.758l-2.7 2.701L2.292.758"/>
</svg>);



// WEBPACK FOOTER //
// ./src/blocks/FilterDateSelect.jsx